import { FILESPACE_V12 } from '#common/types';
import { BasePointerKind } from '#external-files/types';
import { StatsAccumulator } from '#hub-stats';
export var FsIoStatsOperation;
(function (FsIoStatsOperation) {
    FsIoStatsOperation[FsIoStatsOperation["READ_SIZE"] = 0] = "READ_SIZE";
    FsIoStatsOperation[FsIoStatsOperation["WRITE_SIZE"] = 1] = "WRITE_SIZE";
    FsIoStatsOperation[FsIoStatsOperation["COUNT"] = 2] = "COUNT";
})(FsIoStatsOperation || (FsIoStatsOperation = {}));
export var FsIoStatsFileType;
(function (FsIoStatsFileType) {
    FsIoStatsFileType[FsIoStatsFileType["REGULAR_FILE"] = 0] = "REGULAR_FILE";
    FsIoStatsFileType[FsIoStatsFileType["SINGLE_OBJECT_FILE"] = 1] = "SINGLE_OBJECT_FILE";
    FsIoStatsFileType[FsIoStatsFileType["HTTP_LINK_FILE"] = 2] = "HTTP_LINK_FILE";
    FsIoStatsFileType[FsIoStatsFileType["COUNT"] = 3] = "COUNT";
})(FsIoStatsFileType || (FsIoStatsFileType = {}));
export function isFsIoStatsSupported(fsVersion) {
    return fsVersion >= FILESPACE_V12;
}
export function toFsIoStatsFileType(kind) {
    switch (kind) {
        case BasePointerKind.SINGLE_OBJECT:
            return FsIoStatsFileType.SINGLE_OBJECT_FILE;
        case BasePointerKind.HTTP:
            return FsIoStatsFileType.HTTP_LINK_FILE;
        case BasePointerKind.NONE:
        default:
            return FsIoStatsFileType.REGULAR_FILE;
    }
}
function statIdOf(operation, fileType) {
    return (operation << 8) | fileType;
}
export class FsIoStats {
    nodeId;
    kvHelpers;
    enabled;
    accumulator;
    constructor(nodeId, kvHelpers, metaStore, tupleWasm, log, enabled, statsFlusher) {
        this.nodeId = nodeId;
        this.kvHelpers = kvHelpers;
        this.enabled = enabled;
        this.accumulator = new StatsAccumulator(this, metaStore, tupleWasm, log, 'fs io stats');
        if (!this.enabled) {
            return;
        }
        for (let operation = 0; operation < FsIoStatsOperation.COUNT; operation++) {
            for (let fileType = 0; fileType < FsIoStatsFileType.COUNT; fileType++) {
                const key = this.kvHelpers.makeWebFsFsIoStatsKey(this.nodeId, operation, fileType);
                const name = `${FsIoStatsOperation[operation]}/${FsIoStatsFileType[fileType]}`;
                this.accumulator.setupStat(statIdOf(operation, fileType), name, key);
            }
        }
        statsFlusher.register(this.accumulator);
    }
    isEnabled() {
        return this.enabled;
    }
    incrementRead(fileType, size) {
        this.incrementFor(FsIoStatsOperation.READ_SIZE, fileType, size);
    }
    incrementWrite(fileType, size) {
        this.incrementFor(FsIoStatsOperation.WRITE_SIZE, fileType, size);
    }
    toValue(value) {
        return this.kvHelpers.makeFsIoStatsValue(value);
    }
    getRange() {
        return this.kvHelpers.getWebFsFsIoStatsRange(this.nodeId);
    }
    toStatId(key) {
        const { operation, fileType } = this.kvHelpers.getFsIoStatId(key);
        return statIdOf(operation, fileType);
    }
    incrementFor(operation, fileType, size) {
        if (!this.enabled || size <= 0) {
            return;
        }
        this.accumulator.increment(statIdOf(operation, fileType), size);
    }
}
